var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"accent","text":"","loading":_vm.downloading},on:{"click":_vm.downloadFile}},[_vm._v(" "+_vm._s(_vm.showButtonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }